// libraries
import { BootstrapLoadingState } from '@makemydeal/dr-shared-types';
import { sharedBootstrapSelectors } from '@makemydeal/dr-shared-store';
import { offerSessionUtils } from '@makemydeal/dr-shared-ui-utils';
import { sessionExpired } from '@makemydeal/dr-sales-checkin-store';

// interfaces/types
import type { TokenRenewalFailureStore } from '../types/sessionExpired.types';

export const createTokenRenewalFailureHandler = (store: TokenRenewalFailureStore) => (): boolean => {
    if (!offerSessionUtils.isCrmEmbeddedMode()) {
        return false;
    }
    if (sharedBootstrapSelectors.getBootstrapLoadingState(store.getState()) !== BootstrapLoadingState.LoadedSuccessfully) {
        return false;
    }
    store.dispatch(sessionExpired('okta-renewal-failure'));
    return true;
};
